export const COMPANY = {
  name: "Trey's Trucking Logistics",
  legal: "Trey's Trucking Logistics LLC",
  owner: "Nathan Conley III",
  email: "info@treystruckinglogistics.com",
  phone: "409-354-1251",
  phoneHref: "tel:+14093541251",
  address: "15015 Westheimer Pkwy, Ste I2, Suite 310",
  city: "Houston, TX 77082",
  since: "2022",
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const FREIGHT_TYPES = [
  "Reefer / Refrigerated",
  "Specialized Freight",
  "Long-Distance / OTR",
  "Expedited",
  "Dry Van",
  "Flatbed",
];

export const scrollToId = (id) => {
  const el = document.querySelector(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -70 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const scrollTop = () => {
  if (window.__lenis) window.__lenis.scrollTo(0);
  else window.scrollTo({ top: 0, behavior: "smooth" });
};

// Hotlinkable HD stock clips (Mixkit) — arid Texas-style highway freight
export const HERO_VIDEO = "https://assets.mixkit.co/videos/52430/52430-1080.mp4";
export const HERO_VIDEO_ALT = "https://assets.mixkit.co/videos/52434/52434-1080.mp4";

const CDN =
  "https://static.prod-images.emergentagent.com/jobs/7f529f4e-a264-444e-9b1f-bdc61d40f04d/images";

export const ASSETS = {
  logo: `/logo.png`,
  logoEmblem: `/logo.png`,
  heroTruck: `${CDN}/79171d45efed56466c0fe269b2c3e35721a02d1a0206d6aae27a0ab123a5e445.jpeg`,
  flatbed: `${CDN}/dd46554933bc5e746a534c24988e4badc4c3baf33511c51b2a5ab5592f1e6c36.jpeg`,
  fleet: `${CDN}/8d7492db790a17a39a515976a683a35c9b31067517073885c0ecfe794ea44ce4.jpeg`,
  reefer: `${CDN}/c8c5e73fd78ab7d4081835b99958212af3c7bc90a79cdf3fd323def96eea74c0.jpeg`,
  galleryLineup: `${CDN}/efbbd7e084a64744f7021bb6f388784185b27a604e665c4d86b4d3ce8d641577.jpeg`,
  galleryGrille: `${CDN}/19728eeb4448fd0f835f46d54d98303eb8fb6b4b7e3b595c0e03b7ef77c68b91.jpeg`,
  galleryDock: `${CDN}/a77795b48a7cf04a50d5c70b32167b52b0290fdea70edf721b2eba66dd7a410a.jpeg`,
};

export const GALLERY = [
  { src: ASSETS.galleryLineup, alt: "Trey's Trucking fleet lineup at the Houston yard" },
  { src: ASSETS.heroTruck, alt: "Freightliner hauling a dry van on the highway" },
  { src: ASSETS.galleryGrille, alt: "Chrome grille detail of a Trey's Freightliner" },
  { src: ASSETS.reefer, alt: "Refrigerated reefer trailer on the road" },
  { src: ASSETS.galleryDock, alt: "Reefer backed to a Houston loading dock" },
  { src: ASSETS.fleet, alt: "Blue Freightliner cab at the yard" },
  { src: ASSETS.flatbed, alt: "Flatbed hauling secured steel" },
];
